module.exports = __webpack_public_path__ + "fonts/montserrat-regular-webfont.15d62d5f.ttf";